import {
  IProcessFlowStep,
  IProcessFlowVariableMap,
  IProcessFlowVariableMapOptions
} from "~/interfaces/processFlowInterfaces"
import { RelationType } from '~/models/relationType'
import { ITrackedModel } from '~/interfaces/modelInterfaces'
import IRepo from '~/interfaces/repo'
import Repo from '~/state/modules/repo'
import { IClientIdable } from '~/interfaces/propertyInterfaces'
import ProcessFlowBuilderModel from "~/models/tracked/processFlowBuilderModel";
import ProcessFlowMappedVariable from "~/models/processFlows/steps/processFlowMappedVariable";
import {Hash} from "~/interfaces/hashInterfaces";

export class SaveDataVariableMap extends ProcessFlowBuilderModel implements IProcessFlowVariableMap {
  parent: IProcessFlowStep;

  variable_reference: ProcessFlowMappedVariable
  sort_order: number

  constructor(parent: IProcessFlowStep, options: IProcessFlowVariableMapOptions = {firstCreation: false} ) {
    super();
    this.parent = parent;
    this._nameInParent = 'variable_maps'

    this.defineClientId();

    // do not setup defaults when loading json from backend
    // will result in hard-to track down overrides in change tracking
    if (options.firstCreation) {
      this.initDefaults();
    }
  }

  initDefaults() {
    const variableReference = new ProcessFlowMappedVariable('variable_reference');
    variableReference.attachToParent(this)
  }

  // ******************** RELATIONS AND REPOS ******************** //
  static repo: IRepo<SaveDataVariableMap> = new Repo<SaveDataVariableMap>('setDataVariableMaps', SaveDataVariableMap, {});
  repo: IRepo<this>;

  addToRepo(): void {
    SaveDataVariableMap.repo.add(this)
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      "variable_reference": { type: ProcessFlowMappedVariable, relationType: RelationType.singleObject },
    }
  }

  createEmbeddedObject = {
    variable_reference: (parent, json: Hash & Partial<IClientIdable>): ProcessFlowMappedVariable => {
      return new ProcessFlowMappedVariable('variable_reference').loadFromJson(json, parent)
    },
  }

  initializeEmbedded(parent: SaveDataVariableMap & ITrackedModel, item: ProcessFlowMappedVariable, position: number = null, json: Hash = {}, selectItem: boolean = true) {
    item.attachToParent(parent);
    return item
  }

  get collectionKey() {
    // TODO: Alex: make this dynamic depending on what its parent is
    return this._nameInParent
  }

  get rootName(): string {
    return this._nameInParent;
  }

  get isCollectionRoot(): boolean {
    return this._isCollectionRoot = this.parent.EMBEDDED_MODELS[this.rootName].relationType !== RelationType.singleObject;
  }

}